
export const PricingHeader = () => {
  return (
    <div className="text-center max-w-3xl mx-auto mb-12">
      <h1 className="text-4xl font-bold tracking-tight">Simple, Transparent Pricing</h1>
    </div>
  );
};
